﻿import { DropdownMenuItem } from 'components/GMetrixButtonDropdown/GMetrixButtonDropdown';
import { GMetrixTableColumnProps } from 'components/GMetrixTable/components';
import { GMetrixTable } from 'components/GMetrixTable/GMetrixTable';
import { SortDescriptor } from 'utils/dataQuery';
import { useIntl } from 'react-intl';
import { SKU } from 'apis/SKUApi';

interface SKUGMetrixTableProps {
    columnData: GMetrixTableColumnProps<SKU>[];
    detailsDropdownItems?: (dataItem: SKU) => DropdownMenuItem[];
    loadingGridData: boolean;
    onDetailsItemClick?: (dataItem: SKU) => void;
    onSelectedChange?: (selected: SKU[]) => void;
    onServerPageChange?: (skip: number, take: number) => void;
    onServerSortChange?: (sort: SortDescriptor[]) => void;
    searchTerm: string;
    selectableRows?: boolean;
    selectedSKUs?: SKU[];
    serverSidePagination?: boolean;
    serverTotalCount?: number;
    setSearchTerm: (searchTerm: string) => void;
    skus: SKU[];
    toggleColumns?: boolean;
}

export const SKUGMetrixTable = ({
    columnData,
    detailsDropdownItems,
    loadingGridData,
    onDetailsItemClick,
    onSelectedChange,
    onServerPageChange,
    onServerSortChange,
    searchTerm,
    selectableRows = false,
    selectedSKUs,
    serverSidePagination = false,
    serverTotalCount,
    setSearchTerm,
    skus,
    toggleColumns = true
}: SKUGMetrixTableProps) => {

    const { formatMessage } = useIntl();

    return ((
        <GMetrixTable
            bottomBarTableName={formatMessage({ id: 'skus.bc746d1e', defaultMessage: 'SKUs' })}
            columnData={columnData}
            detailsDropdownItems={detailsDropdownItems}
            loading={loadingGridData}
            multiSelect={false}
            onDetailsItemClick={onDetailsItemClick}
            onSelectedChange={onSelectedChange}
            onServerPageChange={serverSidePagination ? onServerPageChange : undefined}
            onServerSortChange={serverSidePagination ? onServerSortChange : undefined}
            rowData={skus}
            searchPlaceholder={formatMessage({ id: 'search_skus_by_identifier_or_name.0a29678b', defaultMessage: 'Search SKUs by identifier or name...' })}
            searchTerm={searchTerm}
            selectableRows={selectableRows}
            selected={selectedSKUs}
            serverSidePagination={serverSidePagination}
            serverTotalCount={serverTotalCount}
            setSearchTerm={setSearchTerm}
            tableName={formatMessage({ id: 'skus.bc746d1e', defaultMessage: 'SKUs' })}
            toggleColumns={toggleColumns}
        />
    ));

};
